import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog,MatDialogRef } from '@angular/material/dialog';

export interface confirmData {
  dialogTitle : string;
  dialogContent : string;
}


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {
  title!: string;
  content! : string;
  yes!:boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: confirmData, private dialog : MatDialog, private dialogRef: MatDialogRef<ConfirmDialogComponent>) {
    this.title = data.dialogTitle;
    this.content = data.dialogContent;
  }

  ngOnInit(): void {
  }
  
  confirm(event : any){
    this.dialogRef.close(event);
    //
  }
}
